import React from 'react';
import {
  useNavigate,
  useLocation,
  useParams,
  matchPath,
} from 'react-router-dom';

function buildHistory(navigate, location) {
  return {
    push: (to, state) => navigate(to, { state }),
    replace: (to, state) => navigate(to, { replace: true, state }),
    go: (delta) => navigate(delta),
    goBack: () => navigate(-1),
    goForward: () => navigate(1),
    location,
  };
}

function buildMatch(path, location, params, end) {
  if (!path) {
    return {
      path: location.pathname,
      url: location.pathname,
      isExact: true,
      params: params || {},
    };
  }

  const match = matchPath({ path, end: end !== false }, location.pathname);
  return {
    path,
    url: match?.pathname || location.pathname,
    isExact: match?.pathname === location.pathname,
    params: match?.params || params || {},
  };
}

export default function RouteElement({ component: Component, path, end, ...rest }) {
  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams();

  const history = buildHistory(navigate, location);
  const match = buildMatch(path, location, params, end);

  return Component ? (
    <Component {...rest} history={history} location={location} match={match} />
  ) : null;
}
